import React, { FC } from "react";
import { IconType } from "./types";

export const TableIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path d="M6 9V11H17.5V9H6ZM12 17H22V15H12V17Z" fill="#BBBBBB" />
    <path d="M14.5 23V21H26V23H14.5Z" fill="#BBBBBB" />
    <path d="M11 17V15H22.5V17H11Z" fill="#BBBBBB" />
  </svg>
);
